import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

const GetMonthsOpt = ({ onLoadingChange, onChange }) => {
    const [options, setOptions] = useState('');
    const [loading, setLoading] = useState(true);
    let isfirst=true;

    useEffect(() => {
        const fetchMonths = async () => {
            try {
                // Fetch data from the server
                const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/Common/putMonths`);
                const data = await response.text();
                
                setOptions(data);
                setLoading(false); // Stop loading when data is fetched
                onLoadingChange(false); // Notify parent that loading is complete
            } catch (error) {
                console.error("Error fetching months:", error);
                setLoading(false);
                onLoadingChange(false); // Stop loading in case of error
            }
        };
        if(isfirst){
        fetchMonths();
        }
        isfirst=false;
    }, [onLoadingChange]);

    return (
        <div>
            {loading ? (
                <Skeleton width={100} height={40} />
            ) : (
                <>
                <select name="month" id="month" dangerouslySetInnerHTML={{ __html: options }} onChange={onChange} />
                 </>
           )}
        </div>
    );
};

const GetMonths = ({ onLoadingChange }) => {
    return (
        <>
            <GetMonthsOpt onLoadingChange={onLoadingChange} />
        </>
    );
}

export default GetMonths;
